import { render, staticRenderFns } from "./BSpinner.vue?vue&type=template&id=792a1f89"
import script from "./BSpinner.vue?vue&type=script&lang=js"
export * from "./BSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports